export default function BrandMark({ event, imageClassName = "h-10 max-w-[180px]", textClassName = "" }) {
  if (event.logoImage) {
    return (
      <img
        src={event.logoImage}
        alt={event.logoAlt || event.name || "Logo"}
        className={`${imageClassName} w-auto object-contain`}
      />
    );
  }

  return <span className={textClassName}>{event.name || "Cuchara Grande"}</span>;
}
